/**
 * Clean text for speech synthesis - removes special characters
 */
export const cleanText = (text: string): string => {
  return text
    // --- Trigonometric functions (natural reading)
    .replace(/\b(sin|cos|tan|cot|sec|csc)\s*\(/gi, '$1 of (')
    .replace(/\bsin\b/gi, 'sine')
    .replace(/\bcos\b/gi, 'cosine')
    .replace(/\btan\b/gi, 'tangent')
    .replace(/\bcot\b/gi, 'cotangent')
    .replace(/\bsec\b/gi, 'secant')
    .replace(/\bcsc\b/gi, 'cosecant')

    // --- Inverse trigonometric functions
    .replace(/\b(sine|cosine|tangent)\s*(?:\^?-1|⁻¹)\s*\(?([a-zA-Z0-9]+)\)?/gi, 'inverse $1 of $2')

    // --- Fractions (a/b → a by b)
    .replace(/(\w+)\s*\/\s*(\w+)/g, '$1 by $2')

    // --- Square root
    .replace(/√\s*\(/g, 'square root of open bracket ')
    .replace(/√\s*([a-zA-Z0-9]+)/g, 'square root of $1')

    // --- Powers (^)
    .replace(/([a-zA-Z0-9]+)\s*\^\s*([a-zA-Z0-9]+)/g, '$1 power $2')

    // --- Superscripts
    .replace(/[²]/g, ' squared ')
    .replace(/[³]/g, ' cubed ')
    .replace(/[⁴]/g, ' to the power 4 ')
    .replace(/[⁵]/g, ' to the power 5 ')
    .replace(/[⁶]/g, ' to the power 6 ')
    .replace(/[⁷]/g, ' to the power 7 ')
    .replace(/[⁸]/g, ' to the power 8 ')
    .replace(/[⁹]/g, ' to the power 9 ')
    .replace(/[⁰]/g, ' to the power 0 ')

    // --- Absolute value
    .replace(/\|([^|]+)\|/g, 'modulus of $1')

    // --- Logarithms
    .replace(/\bln\s*\(/gi, 'natural log of (')
    .replace(/\bln\b/gi, 'natural log')
    .replace(/\blog\s*\(/gi, 'log of (')
    .replace(/\blog\b/gi, 'log')

    // --- Brackets
    .replace(/\(/g, ' open bracket ')
    .replace(/\)/g, ' close bracket ')
    .replace(/\[/g, ' open bracket ')
    .replace(/\]/g, ' close bracket ')
    .replace(/\{/g, ' open bracket ')
    .replace(/\}/g, ' close bracket ')

    // --- Operators
    .replace(/[×*]/g, ' multiplied by ')
    .replace(/[÷]/g, ' divided by ')
    .replace(/[−–—-]/g, ' minus ')
    .replace(/[+]/g, ' plus ')
    .replace(/[=]/g, ' equals ')

    // --- Constants & symbols
    .replace(/[°]/g, ' degrees ')
    .replace(/[π]/gi, ' pi ')
    .replace(/[θ]/gi, ' theta ')

    // --- Separate numbers & letters
    .replace(/([a-zA-Z])(\d)/g, '$1 $2')
    .replace(/(\d)([a-zA-Z])/g, '$1 $2')

    // --- Cleanup
    .replace(/[<>≤≥]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};



/**
 * Highlight thinking words in text (because, so, therefore, etc.)
 * Returns HTML string with highlighted words
 */
export const highlightThinkingWords = (text: string): string => {
  const thinkingWords = ['because', 'so', 'therefore', 'this means', 'since', 'thus', 'hence'];
  let result = text;
  thinkingWords.forEach(word => {
    const regex = new RegExp(`\\b(${word})\\b`, 'gi');
    result = result.replace(regex, '<span class="text-blue-600 font-semibold">$1</span>');
  });
  return result;
};
